<script>
import FormTextarea from "@/components/forms/FormTextarea.vue";

export default {
  name: "TransformationFunctionCode",
  components: {FormTextarea},
  props: {
    transformationFunction: {
      type: Object,
      required: true
    },
    readOnly: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<template>
  <form-textarea
    :disabled="readOnly"
    :label="$t('DEFINITION')"
    :placeholder="$t('TRANSFORMATION_FUNCTION_DEFINITION_PLACEHOLDER')"
    :value="transformationFunction.definition"
    class="mb-4"
    @input="transformationFunction.definition = $event"
  />
</template>
